import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { KeyValueProps } from '../../../../types/Common';
import { typeMappingHandler } from '../../../../constants/keysMapping';
import './circle.scss';

interface CircleChartProps {
  sg1: KeyValueProps[];
  sg2: KeyValueProps[];
  sg3: KeyValueProps[];
  sg4: KeyValueProps[];
}
const CircleChart: React.FC<CircleChartProps> = (props) => {
  const { sg1, sg2, sg3, sg4 } = props;

  return (
    <Box className='circleGridContainer'>
      <Box className='chartContainer'>
        <Box className='quarterCircle2'>
          {sg1.map((i: KeyValueProps) => (
            <Tooltip
              key={i.key}
              title={
                typeMappingHandler(i.key).message?.length > 25
                  ? typeMappingHandler(i.key).message
                  : ''
              }
            >
              <Typography noWrap>{typeMappingHandler(i.key).message}</Typography>
            </Tooltip>
          ))}
        </Box>

        <Box className='quarterCircle1'>
          {sg4.map((i: KeyValueProps) => (
            <Tooltip
              key={i.key}
              title={
                typeMappingHandler(i.key).message?.length > 22
                  ? typeMappingHandler(i.key).message
                  : ''
              }
            >
              <Typography key={i.key}>{typeMappingHandler(i.key).message}</Typography>
            </Tooltip>
          ))}
        </Box>
      </Box>

      <Box className='chartContainer'>
        <Box className='quarterCircle3'>
          {sg2.map((i: KeyValueProps) => (
            <Tooltip
              key={i.key}
              title={
                typeMappingHandler(i.key).message?.length > 25
                  ? typeMappingHandler(i.key).message
                  : ''
              }
            >
              <Typography key={i.key}>{typeMappingHandler(i.key).message}</Typography>
            </Tooltip>
          ))}
        </Box>

        <Box className='quarterCircle4'>
          {sg3.map((i: KeyValueProps) => (
            <Tooltip
              key={i.key}
              title={
                typeMappingHandler(i.key).message?.length > 25
                  ? typeMappingHandler(i.key).message
                  : ''
              }
            >
              <Typography key={i.key}>{typeMappingHandler(i.key).message}</Typography>
            </Tooltip>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CircleChart;
